import type { QueryKey } from "react-query";

import { useGeneralGetHook } from "api/hooks/allHooks";

export const useConfigGroupsQuery = <TGroup>(cacheKey: QueryKey, url: string, enabled: boolean) =>
  useGeneralGetHook<TGroup[]>(cacheKey, url, { enabled });

export const useConfigDetailQuery = <TDetail>(cacheKey: QueryKey, url: string | undefined, enabled: boolean) =>
  useGeneralGetHook<TDetail>(cacheKey, url, { enabled });
